import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';

@Injectable()
export class GetEnvVarService {
  env : any =  "";
  constructor() {
    if(window.location.href.includes("localhost") 
    || window.location.href.includes("https://mediapay.nbcuni.com")) {
      //this.env = JSON.parse(JSON.stringify(environment.stage));
      this.env = Object.assign(environment.stage);
    } else if (window.location.href.includes("https://mediapay.nbcuni.com")) {
      this.env = Object.assign(environment.stage);
    } else if (window.location.href.includes("https://mediapay.nbcuni.com")) {
      this.env = Object.assign(environment.stage);
    } else {
      this.env = Object.assign(environment.stage);
    }
  }

  getAppUrl() {
    return this.env.appurl;  
  }

  getAuthUrl(){
    return this.env.authUrl;  
  }

  getLogoutUri(){
    return this.env.logoutUri;
  }

  getClientId(){
    return this.env.clientId;
  }

  getInvoiceservicebaseurl(){
    return this.env.Invoiceservicebaseurl;
  }

  getUserservicebaseurl(){
    return this.env.Userservicebaseurl;
  }

  getChangePasswordOnForgotPassword(){
    return this.env.ChangePasswordOnForgotPassword;
  }
  
  getAdmin(){
    return this.env.Admin;
  }
  
  getInvoice(){
    return this.env.Invoice;
  }
  
  getRefundApprove(){
    return this.env.RefundApprove;
  }

  getClientSecret(){
    return this.env.clientSecret;
  }

  getIdmurl(){
    return this.env.idmurl;
  }
}
